
export async function queue(promises){
    return await promises.reduce((prev, next) => {
        return prev.then(arg => {
        return next;
        });
    });
}

//将对象转为Promise
//我们经常会遇到不知道对方提供的方法是否需要异步，这个map方法，将对象转为Promise，统一异步操作模式
//该方法只能用于，要么是同步的方法，要么是Promise的返回值的方法
export function map(o){
    if(typeof o === "function"){    //map不能用于 function中有异步的情况
        return wrap((resolve, reject)=>{
            resolve(o.apply(null,[...arguments].slice(1)));
        });
    }
    return Promise.resolve(o);
}
export function wrap(action,catchError){
    return new Promise((resolve, reject) => {
        const _reject = (e)=>{
            if(catchError) catchError(e);
            console.error(e);
            reject(e);
        }
        try{
            action(resolve, _reject);
        }
        catch(e){
            _reject(e);
        }
    });
}

//使用它，避免每次 await 需要try...catch...
export function to(promise) {
    return promise.then(data => [null,data])
    .catch((e)=>[e]);
}

export function empty(){
    return new Promise((resolve, reject) => {
        resolve();
    }); 
}


export function sleep(times){ //times是毫秒
    return wrap((resolve, reject) => {
        setTimeout(() => {
            resolve();
        }, times);
    });
}

